// import React, { memo, useMemo, useState } from 'react';
// import { ChevronDown } from 'lucide-react';

// import { Article, Snippet, SNIPPET_TYPE } from '@repo/types';
// import {
//   Accordion,
//   AccordionContent,
//   AccordionItem,
//   AccordionTrigger,
// } from '@repo/ui/components/ui/accordion';
// import { Badge } from '@repo/ui/components/ui/badge';
// import {
//   Tooltip,
//   TooltipContent,
//   TooltipProvider,
//   TooltipTrigger,
// } from '@repo/ui/components/ui/tooltip';
// import { cn } from '@repo/ui/lib/utils';

// import { DisclaimerSector } from './disclaimer-sector';

// const EmptyState = memo<{ message: string }>(({ message }) => (
//   <div className="flex w-full items-center justify-center p-2">
//     <span className="text-xs font-medium text-cta-dark @cred-md:text-sm @cred-md:leading-[15.2px] @cred-xl:text-base @cred-xl:leading-[21px]">
//       {message}
//     </span>
//   </div>
// ));

// EmptyState.displayName = 'EmptyState';

// const BiasLabel = memo<{ biasLabel: string; biasLabelReasoning?: string }>(
//   ({ biasLabel, biasLabelReasoning }) => {
//     const [accordionValue, setAccordionValue] = useState('');

//     return (
//       <Accordion
//         type="single"
//         value={accordionValue}
//         onValueChange={setAccordionValue}
//         collapsible
//         className="w-full"
//       >
//         <AccordionItem
//           value="bias-label"
//           className="w-full flex flex-col items-center border-none"
//         >
//           <AccordionTrigger hideIcon className="p-0">
//             <Badge
//               variant="outline"
//               className="bg-[#E6ECFF] gap-1.5 rounded-md border-none px-1.5 py-0.5 @cred-md:px-[7px] @cred-md:py-[2.33px] @cred-lg:rounded-[7.6px] @cred-lg:px-[7.6px] @cred-lg:py-[2.53px] @cred-xl:rounded-[10px] @cred-xl:px-2.5 @cred-xl:py-[3.33px]"
//             >
//               <TooltipProvider>
//                 <Tooltip delayDuration={200}>
//                   <TooltipTrigger asChild>
//                     <p className="line-clamp-3 whitespace-break-spaces text-center text-xs font-medium leading-[13px] text-[#1E3A8A] @cred-md:text-sm @cred-md:leading-[15.2px] @cred-lg:text-sm @cred-lg:leading-[16.5px] @cred-xl:text-lg @cred-xl:leading-[21.7px] wrap-break-word">
//                       <b className="font-bold">Bias</b>: {biasLabel}
//                     </p>
//                   </TooltipTrigger>
//                   <TooltipContent className="max-w-72 rounded-md bg-light-blue px-3 py-2 shadow-[1px_2px_4px_rgba(30,30,30,0.4)] @cred-md:max-w-80 @cred-xl:max-w-[440px]">
//                     <div className="flex flex-col">
//                       <p className="text-[10px] font-bold leading-[13px] text-neutral-2 @cred-md:text-[12px] @cred-md:leading-[16px] @cred-xl:text-[14px] @cred-xl:leading-[18px]">
//                         {biasLabel || 'Bias'}
//                       </p>
//                       :{' '}
//                       <p className="text-[10px] font-normal leading-[13px] text-neutral-2 @cred-md:text-[12px] @cred-md:leading-[16px] @cred-xl:text-[14px] @cred-xl:leading-[18px]">
//                         {biasLabelReasoning}
//                       </p>
//                     </div>
//                   </TooltipContent>
//                 </Tooltip>
//               </TooltipProvider>
//               <ChevronDown
//                 className={cn(
//                   'text-[#1E3A8A] cursor-pointer size-4 transition-transform @cred-md:size-[18px] @cred-lg:size-5 @cred-xl:size-6',
//                   accordionValue === 'bias-label' && 'rotate-180',
//                 )}
//               />
//             </Badge>
//           </AccordionTrigger>
//           <AccordionContent className="w-full px-0 pb-0 pt-2">
//             <div className="w-full bg-[#E6EEFF] border-l-[#5F8DEE] border-l-2 px-2.5 py-1.5 rounded-b-2xl">
//               <p className="text-[11px] font-normal leading-[13px] text-neutral-2 @cred-md:text-[13px] @cred-md:leading-[16px] @cred-lg:text-sm @cred-lg:leading-[16.5px] @cred-xl:text-base @cred-xl:leading-[21.7px]">
//                 <b className="font-bold">{biasLabel || 'Bias'}: </b>
//                 {biasLabelReasoning}
//               </p>
//             </div>
//           </AccordionContent>
//         </AccordionItem>
//       </Accordion>
//     );
//   },
// );

// BiasLabel.displayName = 'BiasLabel';

// const CategoryBadge = memo<{ name: string; id: number }>(({ name, id }) => (
//   <Badge
//     key={`${id}-${name}`}
//     variant="outline"
//     className="gap-1 rounded-md border-none bg-[#E6ECFF] px-1.5 py-0.5 text-xs leading-3 text-[#1E3A8A] @cred-md:px-[7px] @cred-md:py-[2.33px] @cred-md:text-sm @cred-md:leading-[14px] @cred-lg:rounded-[7.6px] @cred-lg:px-[7.6px] @cred-lg:py-[2.53px] @cred-lg:text-[15.73] @cred-lg:leading-[15px] @cred-xl:rounded-[10px] @cred-xl:px-2.5 @cred-xl:py-[3.33px] @cred-xl:text-lg @cred-xl:leading-[19px]"
//   >
//     {name}
//   </Badge>
// ));

// CategoryBadge.displayName = 'CategoryBadge';

// const TakeawayItem = memo<{ takeaway: Snippet; index: number }>(
//   ({ takeaway, index }) => (
//     <div className="flex w-full items-center gap-[10.8px] px-2 py-1 first:pt-0 last:pb-0 @cred-md:gap-[9.33px] @cred-md:px-[9.5px] @cred-md:py-[4.5px] @cred-lg:gap-[10.13px] @cred-lg:px-[10.5px] @cred-lg:py-[5px] @cred-xl:gap-[10.6px] @cred-xl:px-3.5 @cred-xl:py-[6.6px]">
//       <span className="text-xs font-bold leading-none text-facts-pie-chart @cred-md:text-base @cred-md:leading-[19px] @cred-lg:leading-[21px] @cred-lg:text-[17.73] @cred-xl:text-2xl @cred-xl:leading-7">
//         {index + 1}
//       </span>
//       <p className="text-xs font-normal leading-[13px] text-neutral-2 @cred-md:text-sm @cred-md:leading-[15.2px] @cred-lg:text-sm @cred-lg:leading-[16.5px] @cred-xl:text-lg @cred-xl:leading-[21.7px]">
//         {takeaway.text}
//       </p>
//     </div>
//   ),
// );

// TakeawayItem.displayName = 'TakeawayItem';

// interface KeyTakeawaysProps {
//   articleMetrics?: Article;
// }

// export const PureKeyTakeaways: React.FC<KeyTakeawaysProps> = ({
//   articleMetrics,
// }) => {
//   const keyTakeaways = useMemo(
//     () =>
//       articleMetrics?.snippets?.filter(
//         (snippet) => snippet.type === SNIPPET_TYPE.KEYTAKEAWAY,
//       ),
//     [articleMetrics?.snippets],
//   );

//   const displayLabels = useMemo(
//     () => articleMetrics?.labels?.filter((_, index) => index <= 1) || [],
//     [articleMetrics?.labels],
//   );

//   const biasLabel = articleMetrics?.metrics?.biasLabel;
//   const biasLabelReasoning = articleMetrics?.metrics?.biasLabelReasoning;
//   const disclaimer = articleMetrics?.metrics?.disclaimer;
//   const credibilityFlag = articleMetrics?.metrics?.credibilityFlag;
//   const hasLabels = articleMetrics?.labels && articleMetrics.labels.length > 0;

//   if (!keyTakeaways) {
//     return (
//       <div className="overflow-hidden rounded-md bg-neutral-1 @cred-md:rounded-lg @cred-lg:rounded-[7.6px] @cred-xl:rounded-[10px]">
//         <EmptyState message="No key takeaways available" />
//       </div>
//     );
//   }

//   if (keyTakeaways.length === 0) {
//     return (
//       <div className="overflow-hidden rounded-md bg-neutral-1 @cred-md:rounded-lg @cred-lg:rounded-[7.6px] @cred-xl:rounded-[10px]">
//         <EmptyState message="No key takeaways found" />
//       </div>
//     );
//   }

//   return (
//     <div
//       className={cn(
//         'overflow-hidden rounded-md bg-neutral-1 @cred-md:rounded-lg @cred-lg:rounded-[7.6px] @cred-xl:rounded-[10px] space-y-2 @cred-md:space-y-[8.67px] @cred-lg:space-y-[10.13px] @cred-xl:space-y-[13.3px]',
//         disclaimer
//           ? 'pt-2 @cred-md:pt-[8.67px] @cred-lg:pt-[10.13px] @cred-xl:pt-[13.3px]'
//           : 'py-2 @cred-md:py-[8.67px] @cred-lg:py-[10.13px] @cred-xl:py-[13.3px]',
//       )}
//     >
//       {hasLabels && (
//         <div className="flex w-full flex-wrap justify-center gap-1 px-2 @cred-md:gap-[4.67px] @cred-md:px-[9.5px] @cred-lg:gap-[5.07px] @cred-lg:px-[10.5px] @cred-xl:gap-[6.6px] @cred-xl:px-2.5">
//           {displayLabels.map((label) =>
//             !label.name ? null : (
//               <CategoryBadge key={label.id} name={label.name} id={label.id} />
//             ),
//           )}
//         </div>
//       )}
//       <div className="flex flex-col">
//         {keyTakeaways.map((takeaway, index) => (
//           <TakeawayItem key={takeaway.id} takeaway={takeaway} index={index} />
//         ))}
//       </div>
//       <div className="flex w-full justify-center px-2 @cred-md:px-[9.5px] @cred-lg:px-[10.5px] @cred-xl:px-2.5">
//         {biasLabel && (
//           <BiasLabel
//             biasLabel={biasLabel}
//             biasLabelReasoning={biasLabelReasoning}
//           />
//         )}
//       </div>
//       {disclaimer && (
//         <DisclaimerSector
//           disclaimer={disclaimer}
//           credibilityFlag={credibilityFlag}
//         />
//       )}
//     </div>
//   );
// };

import React, { memo, useMemo, useState } from 'react';
import { ChevronDown } from 'lucide-react';

import { Article, Snippet, SNIPPET_TYPE } from '@repo/types';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@repo/ui/components/ui/accordion';
import { Badge } from '@repo/ui/components/ui/badge';
import {
  Tooltip,
  TooltipProvider,
  TooltipTrigger,
} from '@repo/ui/components/ui/tooltip';
import { cn } from '@repo/ui/lib/utils';

import { AnalysisTooltipContent } from '@/components/article-analysis/analysis-container';

import { DisclaimerSector } from './disclaimer-sector';

const EmptyState = memo<{ message: string }>(({ message }) => (
  <div className="flex w-full items-center justify-center p-2">
    <span className="text-xs font-medium text-cta-dark @cred-md:text-sm @cred-md:leading-[15.2px] @cred-xl:text-base @cred-xl:leading-[21px]">
      {message}
    </span>
  </div>
));

EmptyState.displayName = 'EmptyState';

const BiasLabel = memo<{
  biasLabel: string;
  biasLabelReasoning?: string;
  accordionValue: string;
  setAccordionValue: (value: string) => void;
}>(({ biasLabel, biasLabelReasoning, accordionValue, setAccordionValue }) => {
  return (
    <Accordion
      type="single"
      value={accordionValue}
      onValueChange={setAccordionValue}
      collapsible
      className="w-full"
    >
      <AccordionItem
        value="bias-label"
        className="w-full flex flex-col items-center border-none"
      >
        <AccordionTrigger
          hideIcon
          className="p-0"
          onClick={(e) => e.stopPropagation()}
        >
          <Badge
            variant="outline"
            className="bg-[#E6ECFF] gap-1.5 rounded-md border-none px-1.5 py-0.5 @cred-md:px-[7px] @cred-md:py-[2.33px] @cred-lg:rounded-[7.6px] @cred-lg:px-[7.6px] @cred-lg:py-[2.53px] @cred-xl:rounded-[10px] @cred-xl:px-2.5 @cred-xl:py-[3.33px]"
          >
            <TooltipProvider>
              <Tooltip delayDuration={200}>
                <TooltipTrigger asChild>
                  <p className="line-clamp-3 whitespace-break-spaces text-center text-xs font-medium leading-[13px] text-[#1E3A8A] @cred-md:text-sm @cred-md:leading-[15.2px] @cred-lg:text-[15.73] @cred-lg:leading-[16.5px] @cred-xl:text-lg @cred-xl:leading-[21.7px] wrap-break-word">
                    <b className="font-bold">Bias</b>: {biasLabel}
                  </p>
                </TooltipTrigger>
                <AnalysisTooltipContent className="z-200 max-w-72 rounded-md bg-light-blue px-3 py-2 shadow-[1px_2px_4px_rgba(30,30,30,0.4)] @cred-md:max-w-80 @cred-xl:max-w-[440px]">
                  <div className="flex flex-col">
                    <p className="text-[10px] font-bold leading-[13px] text-neutral-2 @cred-md:text-[12px] @cred-md:leading-[16px] @cred-xl:text-[14px] @cred-xl:leading-[18px]">
                      {biasLabel || 'Bias'}
                    </p>
                    :{' '}
                    <p className="text-[10px] font-normal leading-[13px] text-neutral-2 @cred-md:text-[12px] @cred-md:leading-[16px] @cred-xl:text-[14px] @cred-xl:leading-[18px]">
                      {biasLabelReasoning}
                    </p>
                  </div>
                </AnalysisTooltipContent>
              </Tooltip>
            </TooltipProvider>
            <ChevronDown
              className={cn(
                'text-[#1E3A8A] cursor-pointer size-4 transition-transform @cred-md:size-[18px] @cred-lg:size-5 @cred-xl:size-6',
                accordionValue === 'bias-label' && 'rotate-180',
              )}
            />
          </Badge>
        </AccordionTrigger>
        <AccordionContent className="w-full px-0 pb-0 pt-2">
          <div className="w-full bg-[#E6EEFF] border-l-[#5F8DEE] border-l-2 px-2.5 py-1.5 rounded-b-2xl">
            <p className="text-xs font-normal leading-tight text-neutral-2 @cred-md:text-sm @cred-lg:text-sm @cred-xl:text-lg">
              <span className="text-xs font-bold leading-tight text-neutral-2 @cred-md:text-sm @cred-lg:text-sm @cred-xl:text-lg">
                {biasLabel || 'Bias'}:{' '}
              </span>
              {biasLabelReasoning}
            </p>
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
});

BiasLabel.displayName = 'BiasLabel';

const CategoryBadge = memo<{ name: string; id: number }>(({ name, id }) => (
  <Badge
    key={`${id}-${name}`}
    variant="outline"
    className="gap-1 rounded-md border-none bg-[#E6ECFF] px-1.5 py-0.5 text-xs leading-3 text-[#1E3A8A] @cred-md:px-[7px] @cred-md:py-[2.33px] @cred-md:text-sm @cred-md:leading-[14px] @cred-lg:rounded-[7.6px] @cred-lg:px-[7.6px] @cred-lg:py-[2.53px] @cred-lg:text-[15.73] @cred-lg:leading-[15px] @cred-xl:rounded-[10px] @cred-xl:px-2.5 @cred-xl:py-[3.33px] @cred-xl:text-lg @cred-xl:leading-[19px]"
  >
    {name}
  </Badge>
));

CategoryBadge.displayName = 'CategoryBadge';

const TakeawayItem = memo<{ takeaway: Snippet; index: number }>(
  ({ takeaway, index }) => (
    <div className="flex w-full items-center gap-[10.8px] px-2 py-1 first:pt-0 last:pb-0 @cred-md:gap-[9.33px] @cred-md:px-[9.5px] @cred-md:py-[4.5px] @cred-lg:gap-[10.13px] @cred-lg:px-[10.5px] @cred-lg:py-[5px] @cred-xl:gap-[10.6px] @cred-xl:px-3.5 @cred-xl:py-[6.6px]">
      <span className="text-xs font-bold leading-none text-facts-pie-chart @cred-md:text-base @cred-md:leading-[19px] @cred-lg:leading-[21px] @cred-lg:text-[17.73] @cred-xl:text-2xl @cred-xl:leading-7">
        {index + 1}
      </span>
      <p className="text-xs font-normal leading-[13px] text-neutral-2 @cred-md:text-sm @cred-md:leading-[15.2px] @cred-lg:text-sm @cred-lg:leading-[16.5px] @cred-xl:text-lg @cred-xl:leading-[21.7px]">
        {takeaway.text}
      </p>
    </div>
  ),
);

TakeawayItem.displayName = 'TakeawayItem';

interface KeyTakeawaysProps {
  articleMetrics?: Article;
}

export const PureKeyTakeaways: React.FC<KeyTakeawaysProps> = ({
  articleMetrics,
}) => {
  const [biasAccordionValue, setBiasAccordionValue] = useState('');

  const keyTakeaways = useMemo(
    () =>
      articleMetrics?.snippets?.filter(
        (snippet) => snippet.type === SNIPPET_TYPE.KEYTAKEAWAY,
      ),
    [articleMetrics?.snippets],
  );

  const displayLabels = useMemo(
    () => articleMetrics?.labels?.filter((_, index) => index <= 1) || [],
    [articleMetrics?.labels],
  );

  const biasLabel = articleMetrics?.metrics?.biasLabel;
  const biasLabelReasoning = articleMetrics?.metrics?.biasLabelReasoning;
  const disclaimer = articleMetrics?.metrics?.disclaimer;
  const credibilityFlag = articleMetrics?.metrics?.credibilityFlag;
  const hasLabels = articleMetrics?.labels && articleMetrics.labels.length > 0;

  const handleCardClick = () => {
    if (biasLabel) {
      setBiasAccordionValue(
        biasAccordionValue === 'bias-label' ? '' : 'bias-label',
      );
    }
  };

  if (!keyTakeaways) {
    return (
      <div className="overflow-hidden rounded-md bg-neutral-1 @cred-md:rounded-lg @cred-lg:rounded-[7.6px] @cred-xl:rounded-[10px]">
        <EmptyState message="No key takeaways available" />
      </div>
    );
  }

  if (keyTakeaways.length === 0) {
    return (
      <div className="overflow-hidden rounded-md bg-neutral-1 @cred-md:rounded-lg @cred-lg:rounded-[7.6px] @cred-xl:rounded-[10px]">
        <EmptyState message="No key takeaways found" />
      </div>
    );
  }

  return (
    <div
      className={cn(
        'overflow-hidden rounded-md bg-neutral-1 @cred-md:rounded-lg @cred-lg:rounded-[7.6px] @cred-xl:rounded-[10px] pt-2 @cred-md:pt-[8.67px] @cred-lg:pt-[10.13px] @cred-xl:pt-[13.3px] space-y-2 @cred-md:space-y-[8.67px] @cred-lg:space-y-[10.13px] @cred-xl:space-y-[13.3px]',
        biasLabel && 'cursor-pointer',
      )}
      onClick={handleCardClick}
    >
      {hasLabels && (
        <div className="flex w-full flex-wrap justify-center gap-1 px-2 @cred-md:gap-[4.67px] @cred-md:px-[9.5px] @cred-lg:gap-[5.07px] @cred-lg:px-[10.5px] @cred-xl:gap-[6.6px] @cred-xl:px-2.5">
          {displayLabels.map((label) =>
            !label.name ? null : (
              <CategoryBadge key={label.id} name={label.name} id={label.id} />
            ),
          )}
        </div>
      )}
      <div className="flex flex-col">
        {keyTakeaways.map((takeaway, index) => (
          <TakeawayItem key={takeaway.id} takeaway={takeaway} index={index} />
        ))}
      </div>
      <div className="flex w-full justify-center px-2 @cred-md:px-[9.5px] @cred-lg:px-[10.5px] @cred-xl:px-2.5">
        {biasLabel && (
          <BiasLabel
            biasLabel={biasLabel}
            biasLabelReasoning={biasLabelReasoning}
            accordionValue={biasAccordionValue}
            setAccordionValue={setBiasAccordionValue}
          />
        )}
      </div>
      {disclaimer && (
        <DisclaimerSector
          disclaimer={disclaimer}
          credibilityFlag={credibilityFlag}
        />
      )}
    </div>
  );
};
